import { Base64 } from 'js-base64';

export class Base64Util
{
  // Base64 encode any Unicode string
  public static encodeUnicode(str: string): string
  {
    const utf8Bytes = new TextEncoder().encode(str);
    return Base64.fromUint8Array(utf8Bytes); // No URL-safe flag needed here
  }

  // Base64 decode to Unicode string
  public static decodeUnicode(base64: string): string
  {
    const bytes = Base64.toUint8Array(base64); // Matches fromUint8Array()
    const rawJsonString = new TextDecoder('utf-8').decode(bytes);

    if (!rawJsonString)
    {
      return null;
    }

    // Replace all carriage returns (\r) and line feeds (\n), and tabs (\t)
    let cleanedString = rawJsonString.replace(/[\r\n\t]+/g, ' ');

    // Fix illegal unescaped backslashes. This targets any backslash NOT followed by a legal escape character (", \, /, b, f, n, r, t, u)
    cleanedString = cleanedString.replace(/\\(?!["\\/bfnrtu])/g, '');

    return cleanedString;
  }
}
